import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import { QuizResultState, QuizType } from "@/models/quiz.model";
import ExamQuizResults from "@/components/quiz/ExamQuizResults.vue";
import QuizCheckableTextQuestion from "@/components/quiz/QuizCheckableTextQuestion.vue";
import ExamQuizQuestionsResults from "@/components/quiz/ExamQuizQuestionsResults.vue";
import SurveyQuizQuestions from "@/components/quiz/SurveyQuizQuestions.vue";
import OpenQuestion from "@/components/quiz/OpenQuestion.vue";
import { PdfExportService } from "@/services/pdfExportService";
let UserQuizzesResultsDialog = class UserQuizzesResultsDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "idAchatCour", void 0);
    _defineProperty(this, "QuizType", QuizType);
    _defineProperty(this, "QuizResultState", QuizResultState);
    _defineProperty(this, "userOverallQuizzes", null);
    _defineProperty(this, "isVisible", true);
    _defineProperty(this, "quizzesLoaded", false);
    _defineProperty(this, "isExporting", false);
    _defineProperty(this, "BASE_API_ANALYTICS", '/api/v2/analytics');
  }
  mounted() {
    this.getQuizzesResults();
  }
  get quizzesResultsExist() {
    return this.userOverallQuizzes?.quizzesResults?.length;
  }
  get quizzesResults() {
    return this.userOverallQuizzes?.quizzesResults || [];
  }
  get quizzesResultsContainerElement() {
    return this.$refs.quizzesResultsContainer;
  }
  getNbTriesMsg(remainingTries) {
    const nbTriesLabel = remainingTries > 1 ? this.$t('analytics.userQuizzesResultsDialog.nbTryPlural') : this.$t('analytics.userQuizzesResultsDialog.nbTrySingular');
    return this.$t('analytics.userQuizzesResultsDialog.remainingTries', {
      count: remainingTries > -1 ? 0 : 1,
      nbRemainingTries: remainingTries,
      nbTryLabel: nbTriesLabel
    });
  }
  getQuizzesResults() {
    axios.get(`${this.BASE_API_ANALYTICS}/quizzesResults?idAchatCour=${this.idAchatCour}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.userOverallQuizzes = response.data;
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    }).finally(() => this.quizzesLoaded = true);
  }
  async exportToPdf() {
    if (!this.quizzesResultsContainerElement) {
      console.error('quizzesResultsContainer element not found');
      return;
    }
    this.isExporting = true;
    try {
      const options = {
        filename: `${"Quizzes-results-" + this.userOverallQuizzes?.userName.replace(/\s+/g, '-')}.pdf`
      };
      await PdfExportService.exportToPdf(this.quizzesResultsContainerElement, options);
    } catch (error) {
      console.error('Export failed:', error);
      WElMessage.showErrorMessage(this.$t('errors.default'));
    } finally {
      this.isExporting = false;
    }
  }
  closePopup() {
    this.isVisible = false;
    this.$emit('closePopup');
  }
};
__decorate([Prop({
  required: true
})], UserQuizzesResultsDialog.prototype, "idAchatCour", void 0);
UserQuizzesResultsDialog = __decorate([Component({
  components: {
    OpenQuestion,
    SurveyQuizQuestions,
    ExamQuizQuestionsResults,
    QuizCheckableTextQuestion,
    ExamQuizResults,
    WDialog,
    StandardButton
  },
  emits: ['closePopup']
})], UserQuizzesResultsDialog);
export default UserQuizzesResultsDialog;